import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { KBQTopLostShoppers } from 'components/KBQSelect'

const initialState: KBQTopLostShoppers[] = []

const topLostShopperSlices = createSlice({
  name: 'TopLostShoppers',
  initialState,
  reducers: {
    setTopLostShoppers(state, action: PayloadAction<KBQTopLostShoppers>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { setTopLostShoppers } = topLostShopperSlices.actions

export default topLostShopperSlices.reducer
